import { CallTimer } from 'features/call/call-timer/components';
import { useCallTimer } from 'features/call/call-timer/hooks';

export const VrsCallCommentsTimer = () => {
  const { duration } = useCallTimer();

  return <CallTimer duration={duration} />;
};
